import React,{useState} from 'react'
import './AllPopover.css';
import { useStateValue } from './StateProvider';

function AllPopover(props) {
    const[{blur,user},dispatch]=useStateValue();
    const[isblur,setIsblur]=useState(false);
    const handleClick=()=>{
        setIsblur(!isblur);
       dispatch({
         type:'SET_BLUR',
         blur:!blur
       });
    }

  return (
    <div className='allpopover'>
      <div className='info'>
        <div className='tocheck'>
          <div className='greeting'>
            <h3>{user?`Hello, ${user.email}`:'Sign In'}</h3>
          </div>
          <div className='exit'>
          <div onClick={handleClick} type='button'>X</div>
         </div>
        </div>

        <div className='adding__scroll'>
        <div className='firsts'>
            <h4>Trending</h4>
            <p>Best Seller</p>
            <p>New Release</p>
            <p>Mover and Shakers</p>
        </div>
        <div className='sec'>
            <h4>Digital & Electronics</h4>
            <p>Echo & Elsa</p>
            <p>Fire Tv</p>
            <p>Kindle E-reader and Books</p>
            <p>Audiable Audiobook</p>
            <p>Amazon Prime Video </p>
            <p>Amazon Prime Music</p>
        </div>
        <div className='third'>
            <h4>Shop By Department</h4>
            <p>Mobile ,Compouter</p>
            <p>TV Appliance,Electronics</p>
            <p>Men's Fashion</p>
            <p>Women's Fashion</p>
        </div>
        <div className='fourth'>
            <h4>Help & Setting</h4>
            <p>Your Account</p>
            <p>Customer Services</p>
            <p>Sign Out</p>
        </div>
        </div>
      </div>
      <div className='tocheck1'>
      
      </div>

    </div>
  )
}

export default AllPopover;